import { get as ENV } from 'react-global-configuration'
import React, { useState, useEffect } from 'react'
import {
  Elements,
  PaymentRequestButtonElement,
  useStripe,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

const CheckoutForm = ({ total, children }) => {
  const stripe = useStripe()
  const [paymentRequest, setPaymentRequest] = useState(null)

  useEffect(() => {
    if (stripe) {
      const pr = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'PDF Total',
          amount: total || 500,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      })
      console.log('paymentRequest created for', total)

      pr.canMakePayment().then(result => {
        console.log('pr.canMakePayment', Boolean(result))
        if (result) {
          window.gtag(
            'event',
            `payment API is available ${result.applePay ? 'applePay' : ''}`,
            { event_category: 'general' }
          )
          if (!result.applePay) {
            setPaymentRequest(pr)
          }
        } else {
          window.gtag('event', `payment API is NOT available`, {
            event_category: 'general',
          })
        }
      })
    }
  }, [stripe, total])

  // if (paymentRequest) {
  //   const onClick = _ => {
  //     paymentRequest.show()
  //   }
  //   return (
  //     <div className="field">
  //       <PaymentRequestButtonElement options={{ paymentRequest }} />
  //     </div>
  //   )
  // }

  return children || null
}

export default function StripePaymentRequestButton(props) {
  return (
    <Elements stripe={loadStripe(ENV('stripePK'))}>
      <CheckoutForm {...props} />
    </Elements>
  )
}



// WEBPACK FOOTER //
// ./src/components/StripePaymentRequestButton.js